export default __webpack_public_path__ + "static/media/Walk (4).d2eab50c.png";